var _defs, _ellipse, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartlogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 200",
    width: 500,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faceTop",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3A3A3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161618"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faceLeft",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26262B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E0E10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faceRight",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33333A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141417"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#000000",
    floodOpacity: 0.35
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 165,
    rx: 65,
    ry: 12,
    fill: "#000000",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "rx",
    values: "65;52;65",
    dur: "6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.35;0.2;0.35",
    dur: "6s",
    repeatCount: "indefinite"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,15)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 60 65",
    to: "360 60 65",
    dur: "6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "translate",
    values: "0 0; 0 -8; 0 0",
    dur: "3s",
    additive: "sum",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.45 0 0.55 1; 0.45 0 0.55 1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "60,10 110,35 60,60 10,35",
    fill: "url(#faceTop)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 73,
    cy: 23,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 4
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "10,35 60,60 60,120 10,95",
    fill: "url(#faceLeft)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 60.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 70.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 77.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 84.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 95.5,
    r: 4
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "110,35 110,95 60,120 60,60",
    fill: "url(#faceRight)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 94.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 77.5,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 60.5,
    r: 4
  })), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 60,
    x2: 110,
    y2: 35,
    stroke: "#55555E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 60,
    x2: 60,
    y2: 120,
    stroke: "#55555E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 60,
    x2: 10,
    y2: 35,
    stroke: "#55555E",
    strokeWidth: 1.5
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 115,
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 64,
    fontWeight: "bold",
    fill: "#0A0A0A"
  }, "Smarlytics")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartlogo2);
export default __webpack_public_path__ + "static/media/smartlogo2.b8674255c00c411df5b797c268ba45ab.svg";
export { ForwardRef as ReactComponent };